<template>
  <div class="card">
    <div class="card-header">
<!--      <h4 class="card-title pull-left">-->
<!--        Preset Replies for Outages-->
<!--      </h4>-->
    </div>
    <div v-if="loading" class="card-body">
      <div class="loader"></div>
    </div>
    <div v-else class="card-body">
      <div class="row">
        <div class="col-md-12">
          <button class="btn btn-sm btn-primary"  @click="addMacro(' {domain}', 'title')">Domain Name</button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
            <label>Title:</label>
            <input type="text" class="form-control" required v-model.trim="newMacro.title">
            <button class="btn btn-sm btn-primary"  @click="addMacro(' {domain}')">Domain Name</button>
            <button class="btn btn-sm btn-primary" @click="addMacro(' {firstName}')">First Name</button>
            <button class="btn btn-sm btn-primary" @click="addMacro(' {lastName}')">Last Name</button>
            <button class="btn btn-sm btn-primary" @click="addMacro(' {email}')">Email</button>
          <!--          signature-->
          <button class="btn btn-sm btn-primary" @click="addMacro(' {signature}')">Signature</button>
            <br>

            <label>Reply:</label>
            <textarea class="form-control" required rows="3" v-model="newMacro.message"></textarea>
            <div class="row">
              <div class="col-md-6">
                <label>Select Status:</label>
                <select class="form-control" v-model="newMacro.status">
                  <option value="Open">Open</option>
                  <option value="Closed">Closed</option>
                  <option value="Client-Reply">Client-Reply</option>
                  <option value="In-Progress">In-Progress</option>
                  <option value="Answered">Answered</option>
                </select>
              </div>
              <div class="col-md-6">
                <label>Select Priority:</label>
                <select class="form-control" v-model="newMacro.priority">
                  <option value="High">High</option>
                  <option value="Low">Low</option>
                  <option value="Medium">Medium</option>
                </select>
              </div>
            </div>
            <button @click="submit" class="btn btn-sm btn-primary float-right" type="submit">{{(editIndex === -1) ? 'Submit' : 'Update'}}</button>
        </div>
      </div>
      <section v-if="presetMacros.length > 0">
        <hr>
        <div class="row">
          <div class="col-md-8">
            <h5>Added Preset Replies</h5>
          </div>
          <div class="col-md-4">
            <button class="btn btn-primary btn-sm pull-right" @click="updateMacro">Update Sorting</button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">
            <b>Title</b>
          </div>
          <div class="col-md-4">
            <b>Reply</b>
          </div>
          <!--                <div class="col-md-2">-->
          <!--                  <b>Status</b>-->
          <!--                </div>-->
          <div class="col-md-2">
            <b>Priority</b>
          </div>
          <div class="col-md-2">
            <b>Action</b>
          </div>
        </div>
        <draggable style="height: 700px; overflow: scroll" class="mt-3" v-model="$parent.presetMacros" group="people" @start="drag=true" @end="drag=false">
          <div class="row macro" v-for="(macro, index) of presetMacros" :key="index">
            <div class="col-md-2">
              <span v-html="(macro.title)? macro.title : ''"></span>
            </div>
            <div class="col-md-4">
              <span v-html="(macro.message) ? macro.message.replace(/\n/g,'<br>') : macro.replace(/\n/g,'<br>')"></span>
            </div>
            <!--                  <div class="col-md-2">-->
            <!--                    {{(macro.status) ? macro.status : ''}}-->
            <!--                  </div>-->
            <div class="col-md-2">
              {{(macro.priority) ? macro.priority : ''}}
            </div>
            <div class="col-md-4">
              <button class="btn btn-sm btn-danger my-1" @click="deleteMacro(index)"><i class="fa fa-trash"></i></button>
              <button class="btn btn-sm btn-primary my-1" @click="editMacro(macro, index)"><i class="fa fa-pencil"></i></button>

            </div>
          </div>
        </draggable>
      </section>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import {db} from "@/firebase/init"
export default {
  name: "outagesPresets",
  components: {
    draggable,
  },
  props: {
    presetMacros: {
      required: true,
      type: Array
    }
  },
  data () {
    return {
      newMacro: {
        title: '',
        message: '',
        status: '',
        priority: ''
      },
      loading: false,
      editIndex: -1
    }
  },
  methods: {
    addMacro (macro, type) {
      if(type==='title'){
        this.newMacro.title+=macro
      }else{
        this.newMacro.message += macro

      }
    },
    deleteMacro (index) {
      this.presetMacros.splice(index, 1)
      this.updateMacro()
    },
    editMacro (macro, index) {
      this.editIndex = index
      if (macro.title !== null && macro.title !== undefined ) {
        this.newMacro = macro
      } else {
        this.newMacro = {
          title: '',
          message: macro,
          status: '',
          priority: ''
        }
      }
      $('#macrosModal').show().scrollTop(0);
    },
    submit () {
      if (this.editIndex === -1) {
        this.presetMacros.push(this.newMacro)
      } else {
        this.presetMacros[this.editIndex] = this.newMacro
        this.editIndex = -1;
      }
      this.newMacro = {
        title: '',
        message: '',
        status: '',
        priority: ''
      }
      this.updateMacro()
    },
    async updateMacro () {
      this.loading = true
      await db.collection('permissions').doc('preset_macros_outages').set({
        replies: this.presetMacros,
      })
      this.loading = false
    }
  }
}
</script>

<style scoped>
.row.macro {
  padding: 10px;
  margin-bottom: 2px;
  border: 1px solid #9b9696;
}
</style>
